import React from "react";
import { Msg } from "react-weui";

export default class Error extends React.PureComponent {
	render() {
		return <Msg type="warn" title="糟糕，遇到了一些问题" description={this.props.msg} />;
	}
}
